// src/modules/coding-opportunities3/IAsystem/mappers/notes.flatten.js

function safeStr(x) {
  if (x === null || x === undefined) return "";
  return String(x);
}

// convierte nota cruda a texto “estable” aunque cambien fields
export function flattenNotesToText(notes = []) {
  const arr = Array.isArray(notes) ? notes : [];
  return arr
    .map((n, i) => {
      const id = n.noteId ?? n.id ?? `note_${i}`;
      const dt = n.noteDateTime ?? n.noteDate ?? n.date ?? "";
      const template = n.templateName ?? n.__group ?? "";
      const provider = n.userName ?? "";
      const signed = n.signedByUser ?? "";
      const reviewed = n.reviewedByUser ?? "";

      // fields dinámicos
      const fields = n.fields && typeof n.fields === "object" ? n.fields : {};
      const fieldsText = Object.entries(fields)
        .map(([k, v]) => `${k}: ${safeStr(v)}`)
        .join("\n");

      return (
        `--- NOTE START ---\n` +
        `note_id: ${safeStr(id)}\n` +
        `date: ${safeStr(dt)}\n` +
        `template: ${safeStr(template)}\n` +
        `provider: ${safeStr(provider)}\n` +
        `signed_by: ${safeStr(signed)}\n` +
        `reviewed_by: ${safeStr(reviewed)}\n` +
        `fields:\n${fieldsText}\n` +
        `--- NOTE END ---\n`
      );
    })
    .join("\n");
}
